import type { DateRange } from "react-day-picker";

import type { FlotiqEventStore } from "../types";

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const getStartOfDay = (date: Date) => {
  const startOfDay = new Date(date);
  startOfDay.setHours(0, 0, 0, 0);
  return startOfDay;
};

const getEndOfDay = (date: Date) => {
  const endOfDay = new Date(date);
  endOfDay.setHours(23, 59, 59, 999);
  return endOfDay;
};

const parseDateOnly = (date: string) => {
  const [year, month, day] = date.split("-").map(Number);

  return new Date(year, month - 1, day);
};

const getEventDate = (date: string, boundary: "start" | "end") => {
  if (!DATE_ONLY_PATTERN.test(date)) {
    return new Date(date);
  }

  const localDate = parseDateOnly(date);

  return boundary === "end" ? getEndOfDay(localDate) : localDate;
};

const isEventInDateRange = (event: FlotiqEventStore, range: DateRange) => {
  const { StartDate, EndDate } = event;

  if (!StartDate) {
    return false;
  }

  const rangeStart = getStartOfDay(range.from as Date);
  const rangeEnd = range.to ? getEndOfDay(range.to) : getEndOfDay(range.from as Date);
  const eventStart = getEventDate(StartDate, "start");
  const eventEnd = EndDate ? getEventDate(EndDate, "end") : eventStart;

  return eventStart <= rangeEnd && eventEnd >= rangeStart;
};

export const getEventsFilteredByDateRange = (
  events: FlotiqEventStore[],
  range: DateRange | undefined
): FlotiqEventStore[] => {
  if (!range?.from) {
    return events;
  }

  return events.filter((event) => isEventInDateRange(event, range));
};
